<template>
    <div class="container">
        <div class="max-w-md">
            <el-card v-for="(item,index) in dataList" :key="index" class="bg-white">
                <el-image :src='item.url' @click="handleTab(item,index)" fit="cover"></el-image>
                <el-button v-if="item.active" type="success" icon="el-icon-check" circle class="sel-icon"></el-button>
            </el-card>
        </div>
        <div class="btn-blank"></div>
        <div class="btn-fixed">
            <!-- <div class="sel-num">已选中{{ selNum }}个</div> -->
            <el-button v-if="downloadUrl && browserName == '其他浏览器'" class="btn-down" size="small" type="primary" round>
                <a style="color: #fff;text-decoration: none;" :href="downloadUrl" download="test.png" target="_blank">下载</a>
            </el-button>
            <el-button v-else-if="downloadUrl && browserName != '其他浏览器'" @click="saveImage" class="btn-down" size="small" type="primary" round>
                下载
            </el-button>
            <el-button v-else class="btn-down" size="small" type="info" round>下载</el-button>
        </div>
    </div>
</template>

<script>
const request_base_path = require('@/utils/base_url')
import { getTempFilelist } from "@/api/common"
export default {
    name: "scanPicture",
    data() {
        return {
            base_url: request_base_path.pro_url,
            browserName: '',
            temp_key: '',
            selNum: 0,
            dataList: [],
            downloadUrl: '',
        }
    },
    created() {
        // 获取扫码密钥
        this.temp_key = this.$route.query.temp_key;
        this.$nextTick(()=>{
            this.loadObj();
        })
        const ua = navigator.userAgent.toLowerCase();
		// 检测是否在微信内
		const isWechat = /micromessenger/i.test(ua);
		if (!isWechat) {
			this.browserName = '其他浏览器'
			return 'unknown'; // 不在微信内
		}
		// 检测是否在企业微信内
		const isWorkWechat = /wxwork/i.test(ua);
		if (isWorkWechat) {
			this.browserName = '企业微信'
			return 'workWechat'; // 在企业微信内
		} else {
            this.browserName = '普通微信'
			return 'wechat'; // 在普通微信内
		}
    },
    methods: {
        // 批量下载图片
        // downloadImages() {
        //     this.imageList.forEach((imgUrl, index) => {
        //         this.downloadSingleImg(imgUrl, `图片${index + 1}.jpg`);
        //     });
        // },
        // // 单张图片下载
        // downloadSingleImg(imgUrl, fileName) {
        //     // 解决跨域图片无法下载的问题
        //     let xhr = new XMLHttpRequest();
        //     xhr.open("GET", imgUrl, true);
        //     xhr.responseType = "blob";
        //     xhr.onload = () => {
        //         let url = window.URL.createObjectURL(xhr.response);
        //         let a = document.createElement("a");
        //         a.href = url;
        //         a.download = fileName; // 自定义文件名
        //         a.click();
        //         window.URL.revokeObjectURL(url); // 释放内存
        //     };
        //     xhr.send();
        // },
        handleTab(item,index){
            this.dataList.map(res=>{
                res.active = false
            })
            item.active = true
            this.downloadUrl = item.url
            // if(item.active){
            //     item.active = false
            // }else{
            //     item.active = true
            // }
            // let selNum = 0
            // this.dataList.map(res=>{
            //     if(res.active){
            //         selNum = selNum + 1
            //     }
            // })
            // this.selNum = selNum
        },
        loadObj(){
            let params = {
                temp_key: this.temp_key,
            }
            console.log("传递",params)
            getTempFilelist(params).then((response) => {
                this.dataList = response.data;
                this.dataList.map(item=>{
                    item.active = false
                })
            })
            .catch((error) => {
            });
        },
        async saveImage() {
            // 创建临时input
            const input = document.createElement("input");
            input.value = window.location.href;
            document.body.appendChild(input);
            
            // 选中并复制
            input.select();
            document.execCommand("copy");
            
            // 移除临时元素
            document.body.removeChild(input);

            alert("当前链接已复制，请在外部浏览器打开")
        },
        
    },
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    .max-w-md {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .bg-white{
            width: 47%;
            margin: 5px auto;
            position: relative;
            .sel-icon{
                position: absolute;
                top: 0;
                right: 0;
            }
        }
    }
    .btn-blank{
        width: 100%;
        height: 80px;
    }
    .btn-fixed{
        width: 100%;
        height: 80px;
        background-color: rgba(255,255,255,1);
        z-index: 999;
        display: flex;
        position: fixed;
        bottom: 0;
        left: 0;
        .sel-num{
            width: 60%;
            box-sizing: border-box;
            padding: 0 0 0 20px;
            color: #121212;
            font-size: 16px;
            line-height: 80px;
        }
        .btn-down{
            width: 120px;
            height: 50px;
            margin: 15px 0 0 30px;
            font-size: 16px;
        }
    }
}

/* 自定义样式 */
::v-deep .el-card__body {
    text-align: center;
    padding: 14px 14px 9px;
}

</style>